module.exports = __webpack_public_path__ + "img/Customer.38178cff.svg";